module.exports = __webpack_public_path__ + "static/media/ic_delivery.0631e90f.svg";